export default __webpack_public_path__ + "static/shop-widget-377991900628e39af65b00d17318c7aa.webp";